module.exports = __webpack_public_path__ + "63ac75c5f5d3981c8add82a7603b60e4.png";